import Vue from 'vue'
import { Autosize } from '@/shared/directives/autosize'
import { StickyBlock } from '@/shared/directives/sticky-block'
import { Autofocus } from '@/shared/directives/autofocus'

Vue.directive('autofocus', Autofocus)
Vue.directive('autosize', Autosize)
Vue.directive('stickyblock', StickyBlock)
